module.exports = __webpack_public_path__ + "static/media/background_2x.e166a09c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/washington-dc/background_2x.jpg
// module id = 912
// module chunks = 27